import { z } from 'zod';

export const groupSubscriptionSchema = z.object({
  id: z.string().optional(),
  startDate: z.any().nullish(),
  endDate: z.any().nullish(),
});

export type TGroupSubscriptionSchema = z.infer<typeof groupSubscriptionSchema>;
